<template>
  <div class="question-tabs" role="tablist">
    <button
      v-for="(tab, i) in tabs"
      :key="i"
      type="button"
      role="tab"
      class="question-tabs__tab"
      :aria-selected="i === current ? 'true' : 'false'"
      @click="$emit('select', i)"
    >
      <i v-if="tab.done" class="fas fa-check" aria-label="answered"></i>
      <i
        v-else-if="tab.missed"
        class="fas fa-ban"
        aria-label="not answered"
      ></i>
      {{ tab.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionTabs",
  props: {
    /** `[{label, done, missed}]`, one per tab. */
    tabs: { type: Array, required: true },
    current: { type: Number, required: true },
  },
  emits: ["select"],
};
</script>

<style lang="scss" scoped>
.question-tabs {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 2px;
}

.question-tabs__tab {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 36px;
  padding: 4px 12px;
  border: 1px solid rgba(127, 127, 127, 0.25);
  border-radius: 999px;
  background: transparent;
  color: var(--oliver-text-muted);
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &[aria-selected="true"] {
    border-color: var(--oliver-accent);
    background: var(--oliver-indicator-bg);
    color: var(--oliver-accent);
  }

  &:focus-visible {
    outline: 2px solid var(--oliver-accent);
    outline-offset: 2px;
  }

  i {
    font-size: 10px;
  }
}
</style>
